import { render, staticRenderFns } from "./OpenfoldSetup.vue?vue&type=template&id=3922fd57"
import script from "./OpenfoldSetup.vue?vue&type=script&lang=ts"
export * from "./OpenfoldSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports